import { MOCK_TYPE } from '../FetchAdapter';
import {
    AEM_CONTENT,
    ENTITLEMENTS_ALL_PERMIT,
    MEMBER_BENEFITS_DATA,
    MEMBER_DATA,
    MEMBER_SUPPLEMENTAL_DATA,
    TOKENS_DATA,
} from '../../Components/Mocks/MockData';

/*
Bob Basic

Bob Basic is a basic member with a single dependent.
*/

const BFF_BASE_URL = window.__ENV__.BFF_URL;
const mockMap = {};
const OK = 200;

mockMap[`${BFF_BASE_URL}/transfer/v1/in`] = {
    type: MOCK_TYPE.REST,
    operations: {
        POST: {
            response: {
                status: OK,
                body: {
                    tokens: TOKENS_DATA.tokens,
                },
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/aem/v2/content`] = {
    type: MOCK_TYPE.REST,
    operations: {
        GET: {
            response: {
                status: OK,
                body: AEM_CONTENT.data,
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/log/v3/send`] = {
    type: MOCK_TYPE.REST,
    operations: {
        POST: {
            response: {
                status: OK,
                body: {},
            },
        },
    },
};

mockMap[`${BFF_BASE_URL}/api/v2`] = {
    type: MOCK_TYPE.GRAPHQL,
    operations: {
        EntitlementsQuery: {
            response: {
                status: OK,
                body: {
                    data: ENTITLEMENTS_ALL_PERMIT,
                },
            },
        },
        GetMemberQuery: {
            response: {
                status: OK,
                body: {
                    data: MEMBER_DATA,
                },
            },
        },
        GetMemberSupplementalQuery: {
            response: {
                status: OK,
                body: {
                    data: MEMBER_SUPPLEMENTAL_DATA,
                },
            },
        },
        GetMemberBenefitsQuery: {
            response: {
                status: OK,
                body: {
                    data: MEMBER_BENEFITS_DATA,
                },
            },
        },
        GetFamilyQuery: {
            response: {
                status: OK,
                body: {
                    data: {
                        member: {
                            familyMembers: [
                                {
                                    personId: '1',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    firstName: 'Billy',
                                    lastName: 'Basic',
                                    birthDate: '2005-01-01',
                                    gender: 'FEMALE',
                                    benefits: [
                                        {
                                            memberBenefitId: '1',
                                            status: 'ACTIVE',
                                            covered: false,
                                            benefitName: 'Health',
                                            code: 'EHC',
                                            cobRequired: true,
                                            cob: {
                                                hasOtherInsurer: true,
                                                otherInsurerName: 'OTHER',
                                            },
                                            eligibleForCoverage: true,
                                        },
                                        {
                                            memberBenefitId: '2',
                                            status: 'ACTIVE',
                                            covered: false,
                                            benefitName: 'Dental',
                                            cobRequired: true,
                                            cob: {
                                                hasOtherInsurer: true,
                                                otherInsurerName: 'OTHER',
                                            },
                                        },
                                    ],
                                },
                                {
                                    personId: '2',
                                    firstName: 'Jane',
                                    lastName: 'Smith',
                                    birthDate: '1999-11-11',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    isStudentStatusExtendable: true,
                                    gender: 'FEMALE',
                                    benefits: [
                                        {
                                            memberBenefitId: '1',
                                            covered: true,
                                            benefitName: 'Health',
                                            cob: {
                                                hasOtherInsurer: false,
                                                otherInsurerName: 'OTHER',
                                            },
                                        },
                                        {
                                            memberBenefitId: '2',
                                            covered: false,
                                            benefitName: 'Dental',
                                            cob: {
                                                hasOtherInsurer: false,
                                                otherInsurerName: 'OTHER',
                                            },
                                        },
                                    ],
                                },
                                {
                                    personId: '3',
                                    firstName: 'Jack',
                                    lastName: 'Smith',
                                    birthDate: '2000-11-11',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    isStudentStatusExtendable: true,
                                    benefits: [
                                        { benefitName: 'Health', covered: false },
                                        { benefitName: 'Dental', covered: false },
                                    ],
                                },
                                {
                                    personId: '4',
                                    firstName: 'Jonathan',
                                    lastName: 'Smith',
                                    birthDate: '2000-01-01',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    isStudentStatusExtendable: true,
                                    benefits: [
                                        { benefitName: 'Health', covered: false },
                                        { benefitName: 'Dental', covered: false },
                                    ],
                                },
                                {
                                    personId: '5',
                                    firstName: 'Dan',
                                    lastName: 'Smith',
                                    birthDate: '2001-01-01',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    isStudentStatusExtendable: true,
                                    benefits: [
                                        { benefitName: 'Health', covered: false },
                                        { benefitName: 'Dental', covered: false },
                                    ],
                                },
                                {
                                    personId: '6',
                                    firstName: 'Noteligible',
                                    lastName: 'Smith',
                                    birthDate: '2001-01-01',
                                    familyMemberType: 'CHILD',
                                    status: 'ACTIVE',
                                    benefits: [
                                        { benefitName: 'Health', covered: false },
                                        { benefitName: 'Dental', covered: false },
                                    ],
                                },
                                {
                                    personId: '7',
                                    firstName: 'Donald',
                                    lastName: 'Smith',
                                    birthDate: '2001-01-01',
                                    familyMemberType: 'CHILD',
                                    status: 'TERMINATED',
                                    isStudentStatusExtendable: true,
                                    specialDependent: 'DISABLED',
                                    benefits: [
                                        { benefitName: 'Health', covered: false },
                                        { benefitName: 'Dental', covered: false },
                                    ],
                                },
                            ],
                            allowedDependentActions: {
                                addSpouse: true,
                                updateSpouse: true,
                                addChild: true,
                                updateChild: true,
                                extendStudent: true,
                            },
                        },
                    },
                },
            },
        },
        UpdateMemberPhoneNumberMutation: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        UpdateMemberPostalAddressMutation: {
            response: {
                status: OK,
                body: {
                    data: { updateMemberPostalAddress: { addressId: '1' } },
                },
            },
        },
        BankQuery: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
            // Set the variables into state so that the GetBank hook can access them
            onBeforeResponse({ options, adapterState }) {
                const variables = JSON.parse(options.body).variables;
                adapterState.set('BANK_UPDATE_VARIABLES', variables);
            },
            onAfterResponse({ response, adapterState }) {
                const { bankBranchNumber, bankInstitutionNumber } = adapterState.get('BANK_UPDATE_VARIABLES');
                const modifiedResponse = { ...response };

                // Check to see if the branch and institution number are valid and return bank name if it is
                modifiedResponse.body.data.bank =
                    bankBranchNumber === '05012' && bankInstitutionNumber === '540'
                        ? { bankName: 'MANULIFE BANK OF CANADA' }
                        : null;

                return modifiedResponse;
            },
        },
        CreateMemberBankAccountMutation: {
            response: {
                status: OK,
                body: {
                    data: { createMemberBankAccount: { bankAccountId: '10101' } },
                },
            },
        },
        UpdateMemberBankAccountMutation: {
            response: {
                status: OK,
                body: {
                    data: { updateMemberBankAccount: { bankAccountId: '10101' } },
                },
            },
        },
        UpdateMemberEmailAddressMutation: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        createFamilyMember: {
            response: {
                status: OK,
                body: {
                    data: { createFamilyMember: { personId: '999' } },
                },
            },
        },

        createFamilyMemberCOBs: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        createOrUpdateFamilyMemberCOBs: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        FamilyMemberExtendStudentStatus: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        CommitChangesMutation: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
        RemoveApplicationState: {
            response: {
                status: OK,
                body: {
                    data: {},
                },
            },
        },
    },
};

export default mockMap;
